import React, { useState, useRef, useEffect, useMemo } from "react"
import { ThemeProvider } from "styled-components"

import articleThemeExtension from "utils/articleThemeExtension"
import useAdTargeting from "components/article/hooks/useAdTargeting"
import useProgress from "../../hooks/useProgress"

import { NetworkAdUnit, CloseButton, ArrowIcon } from "./styles"

const LeaderboardAd = ({ article, breaking = false, slotId, ...props }) => {
  const { category, nsfw } = article
  const theme = articleThemeExtension(category)

  const targetingOptions = useMemo(() => useAdTargeting(article), [article])
  // locked state:
  //  - ad container is sticky (covers the navigation)
  //  - show close button
  const [isLocked, setLocked] = useState(false)
  // closed state:
  //  - has been closed because we scrolled to the bottom of the hero image
  //  - will not go into locked state again
  const closedRef = useRef(false)
  // hidden state:
  //  - ad has been manually closed by clicking on the close button
  //  - ad container is removed completely
  const [isHidden, setHidden] = useState(false)

  const handleHide = (event) => {
    if (event.type?.toLowerCase() === "click" || event.code === "Enter" || event.code === "Space") {
      event.preventDefault()
      setLocked(false)
      closedRef.current = true
      setHidden(true)
      const wrapper = containerRef.current.parentNode
      wrapper.style.display = "none"
    }
  }

  useProgress((currentProgress) => {
    if (!breaking && !closedRef.current) {
      const navigationHeight = document.querySelector("#article-navigation")?.offsetHeight || 0
      const headerImageBottom =
        document.querySelector("#article-header-image")?.getBoundingClientRect()?.bottom ||
        window.innerHeight * 0.95 - document.documentElement.scrollTop

      setLocked(currentProgress !== 0 && headerImageBottom - navigationHeight > 0)
      closedRef.current = headerImageBottom - navigationHeight <= 0
    }
  }, article.id)

  const containerRef = useRef()
  useEffect(() => {
    if (closedRef.current && !isLocked && containerRef.current) {
      const wrapper = containerRef.current.parentNode
      wrapper.style.position = "relative"
      wrapper.style.zIndex = 1
      wrapper.style.top = "unset"
    }
  }, [isLocked])

  return (
    <ThemeProvider theme={theme}>
      {!isHidden && (
        <div ref={containerRef}>
          <NetworkAdUnit
            placementName="mindbodygreen-com_ATF_leaderboard"
            nsfw={nsfw}
            targetingOptions={targetingOptions}
            {...props}
          />
          {!closedRef.current && isLocked && (
            <CloseButton onClick={handleHide} onKeyUp={handleHide} tabIndex={0}>
              Close Banner
              <ArrowIcon id="greater-than-icon" width="9" height="16" />
            </CloseButton>
          )}
        </div>
      )}
    </ThemeProvider>
  )
}

export default LeaderboardAd
